# <template>
#   <section id="sponsor">
#     <div class="row">
#       <div class="columns small-12 medium-10 medium-offset-1">
#         <h4>{{ conf.menu.sponsor }}</h4>
#         <div class="row">
#           <diamond-sponsor v-for="sponsor in conf.diamondsponsors" :sponsor="sponsor" :conf="conf"></diamond-sponsor>
#         </div>
#         <silver-sponsor-row v-for="sponsorRow in silverSponsorRows" :sponsor-row="sponsorRow" :conf="conf"></silver-sponsor>
#       </div>
#     </div>
#   </section>
# </template>
#
# <script lang="coffee" type="text/coffeescript">
module.exports =
  components:
    'diamond-sponsor': require './DiamondSponsor.vue'
    'silver-sponsor-row': require './SilverSponsorRow.vue'
  props: ['conf']
  computed:
    silverSponsorRows: () ->
      rows = []
      temp = []
      for sponsor, index in @conf.silversponsors
        temp.push(sponsor)
        if (index+1) % 2 == 0
          rows.push(temp)
          temp = []
      return rows
# </script>
#
# <style lang="sass?indentedSyntax" type="text/sass">
#   @import '../settings.scss'
#
#   #sponsor
#     h4
#       text-align: center
#       margin-top: 4rem
#       margin-bottom: 2rem
#     .sponsor-wrapper
#       float: left
#       &.silver
#         margin: 1.5rem 0 0
#       &.silver:nth-child(2n)
#         padding-left: .6rem
#       &.silver:nth-child(2n+1)
#         padding-right: .6rem
#       &.diamond
#         margin-top: 1.5rem
#     .sponsor
#       border: #e4e4e4 solid 1px
#       padding: 1.5rem
#       box-shadow: 0 0 5px #e8e8e8
#       .photo
#         background-position: center center
#         background-repeat: no-repeat
#         background-size: contain
#         height: 10rem
#         +breakpoint(small only)
#           height: 8rem
#       h6
#         color: map-get($foundation-palette, primary)
#         font-weight: 500
#       p
#         text-align: justify
#       .moreBtn
#         display: none
#     .more
#       position: relative;
#       p.description
#         height: 0rem
#         overflow: hidden
#       .moreBtn
#         display: block
#         position: absolute;
#         width: 1.5em;
#         height: 1.5em;
#         right: 0.6rem;
#         bottom: 0;
#         overflow: hidden;
#         text-indent: -999em;
#         background-color: $primary-color;
#         box-shadow: inset 0 0 5px rgba(black, 0.7);
#         &:after
#           content: ' ';
#           position: absolute;
#           width: 100%;
#           height: 100%;
#           top: -50%;
#           left: -50%;
#           transform: rotate(45deg) scale(1.4);
#           background-color: white;
#           box-shadow: 0 0 5px rgba(black, 0.7);
#     .diamond.more
#       p.description
#         height: 6.5rem;
#       .moreBtn
#         right: 1.4rem;
#         +breakpoint(small only)
#           right: 0.75rem;
#     .diamond
#       .photo
#         +breakpoint(small only)
#           margin-bottom: 2rem
# </style>



/** WEBPACK FOOTER **
 ** ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/Sponsor.vue
 **/